var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"0"},attrs:{"src":"https://new-wx.ylyk.com/static/userAgreement.html"}})])
}]

export { render, staticRenderFns }